if (!customElements.get('amora-cross-sell')) {
  customElements.define('amora-cross-sell', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const data = this.querySelector('[data-cross-data]');
      if (!data) return;
      this.variants = JSON.parse(data.textContent);
      this.select = this.querySelector('[data-cross-variant]');
      this.button = this.querySelector('[data-cross-add]');
      this.status = this.querySelector('[data-cross-status]');
      this.ready = true;
      this.button.hidden = false;
      this.querySelector('.amora-cross-sell__view').hidden = true;
      this.select.addEventListener('change', event => { event.stopPropagation(); this.update(); });
      this.button.addEventListener('click', () => this.add());
      this.buildChoices();
      this.update();
    }
    buildChoices() {
      this.optionNames = JSON.parse(this.querySelector('[data-cross-options]').textContent);
      this.choices = this.querySelector('[data-cross-choices]');
      this.optionNames.forEach((name, index) => {
        const field = document.createElement('fieldset');
        const legend = document.createElement('legend');
        legend.textContent = name;
        field.append(legend);
        const values = [...new Set(this.variants.map(variant => variant.options[index]))];
        if (/momme|weight/i.test(name)) {
          field.className = 'amora-cross-sell__weight';
          values.forEach(value => {
            const label = document.createElement('label');
            const input = document.createElement('input');
            input.type = 'radio';
            input.name = 'cross-' + this.select.id + '-' + index;
            input.value = value;
            input.dataset.optionIndex = index;
            const text = document.createElement('span');
            text.textContent = value;
            label.append(input, text);
            field.append(label);
          });
        } else {
          const select = document.createElement('select');
          select.dataset.optionIndex = index;
          select.setAttribute('aria-label', name);
          values.forEach(value => select.add(new Option(value, value)));
          field.append(select);
        }
        this.choices.append(field);
      });
      this.choices.addEventListener('change', event => {
        event.stopPropagation();
        const index = Number(event.target.dataset.optionIndex);
        const value = event.target.value;
        const candidates = this.variants.filter(variant => variant.available && variant.options[index] === value);
        candidates.sort((a, b) => {
          const score = variant => variant.options.reduce((total, option, i) => total + (option === this.variant.options[i] ? (i < index ? 10 : 1) : 0), 0);
          return score(b) - score(a);
        });
        if (candidates[0]) this.select.value = String(candidates[0].id);
        this.update();
      });
      this.querySelector('[data-cross-fallback]').hidden = true;
      this.choices.hidden = false;
    }
    syncChoices() {
      if (!this.choices || !this.variant) return;
      this.choices.querySelectorAll('[data-option-index]').forEach(control => {
        const index = Number(control.dataset.optionIndex);
        const available = value => this.variants.some(variant => variant.available && variant.options[index] === value && variant.options.slice(0, index).every((option, i) => option === this.variant.options[i]));
        if (control.type === 'radio') {
          control.checked = control.value === this.variant.options[index];
          control.disabled = this.busy || !available(control.value);
        } else {
          control.value = this.variant.options[index];
          control.disabled = !!this.busy;
          Array.from(control.options).forEach(option => option.disabled = !available(option.value));
        }
      });
    }
    update() {
      this.variant = this.variants.find(v => String(v.id) === this.select.value);
      this.button.disabled = !this.variant?.available;
      if (!this.variant) return;
      this.querySelector('[data-cross-price]').textContent = this.variant.price;
      this.querySelector('[data-cross-photo]').src = this.variant.photo;
      this.querySelector('[data-cross-photo]').alt = this.querySelector('h2').textContent.trim() + ' — ' + this.variant.title;
      this.querySelectorAll('[data-cross-link]').forEach(link => link.href = this.variant.url);
      this.status.textContent = '';
      this.syncChoices();
    }
    async add() {
      if (this.busy || !this.variant?.available) return;
      this.busy = true;
      this.select.disabled = true;
      this.syncChoices();
      this.button.disabled = true;
      this.button.textContent = this.dataset.adding;
      this.status.textContent = '';
      try {
        const response = await fetch(this.dataset.addUrl, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:this.variant.id,quantity:1}]})});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        this.status.textContent = error.message || this.dataset.error;
        this.busy = false;
        this.select.disabled = false;
        this.syncChoices();
        this.button.disabled = !this.variant.available;
        this.button.textContent = this.dataset.add;
      }
    }
  });
}
